export * from './activityController.service';
import { ActivityControllerService } from './activityController.service';
export const APIS = [ActivityControllerService];
